"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PageProvider;
var _reactRouter = require("react-router");
var _reactHelmetAsync = require("react-helmet-async");
var _data = require("../stores/data");
var _ServerError = _interopRequireDefault(require("../components/ServerError"));
var _ScrollProvider = _interopRequireDefault(require("./ScrollProvider"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function PageProvider(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouter.BrowserRouter, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHelmetAsync.HelmetProvider, {
      prioritizeSeoTags: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_data.DataProvider, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ScrollProvider["default"], {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ServerError["default"], {}), props.children]
        })
      })
    })
  });
}